// VehicleTextureHelper.js - 战车纹理 key 解析（兼容旧存档 战车N 命名）
import { RESOURCE_CONFIG } from './ResourceConfig.js';

const LEGACY_TANK_MAP = Object.fromEntries(
    Array.from({ length: 11 }, (_, i) => [`战车${i + 1}`, `tank${i + 1}`])
);

const TANK_TEXTURE_KEYS = new Set(
    (RESOURCE_CONFIG.tanks || [])
        .map((tank) => tank.key)
        .filter((key) => key && key.startsWith('tank'))
);

/**
 * 解析战车精灵图纹理 key（世界/战斗/HUD 共用）
 * @param {{ name?: string, element?: string }|null|undefined} vehicle
 * @returns {string|null}
 */
export function getVehicleTextureKey(vehicle) {
    if (!vehicle) return null;

    const raw = vehicle.name || vehicle.element;
    if (!raw) return null;

    return LEGACY_TANK_MAP[raw] || raw;
}

/**
 * @param {string|null|undefined} textureKey
 * @returns {boolean}
 */
export function isTankSpritesheetKey(textureKey) {
    return !!textureKey && TANK_TEXTURE_KEYS.has(textureKey);
}
